document.addEventListener('DOMContentLoaded', () => {
    function initTicker() {
        const tickerElements = document.querySelectorAll('.pdp-auto-ticker');

        tickerElements.forEach((tickerElement) => {
            const noteListElements = tickerElement.querySelectorAll('.note_list');

            noteListElements.forEach((noteList) => {
                const notes = noteList.querySelectorAll('p');

                if (notes.length === 0) return;

                const firstNote = notes[0];
                firstNote.classList.add('active');

                function autoChange() {
                    const activeNote = noteList.querySelector('p.active');

                    if (!activeNote) {
                        return;
                    }
                    activeNote.classList.remove('active');

                    const nextNote = activeNote.nextElementSibling || notes[0];
                    nextNote.classList.add('active');
                }

                setInterval(autoChange, 2000);
            });
        });
    }

    // Check for lazy loading
    if (window.lazyResources && !window.lazyResources.loaded) {
        window.lazyResources.loadAll();
        setTimeout(initTicker, 100); // Slight delay to ensure elements exist
    } else {
        initTicker();
    }
});